import './formLabel.scss';
import React, { Fragment } from 'react';
import { classSet } from '@umu/umu-dom';

export interface IFormLabelProps {
    label?: string | JSX.Element;
    isRequire?: boolean;
    isShowError?: boolean;
    errorMsg?: string;
    className?:string;
    children: string | JSX.Element;
}

export const FormLabel = (props: IFormLabelProps) => {
    const { label, children, errorMsg = '', isRequire = false, isShowError = false, className = '' } = props;
    const ElementErrorMsg = isShowError && errorMsg ? <div className="tip-error-msg tip-error-links">{errorMsg}</div> : null;
    return (
        <Fragment>
            {label && (
                <div
                    className={classSet({
                        'form-label': true,
                        'form-require': isRequire,
                    })}
                >
                    {label}
                </div>
            )}
            <div className={`form-children ${className}`}>{children}</div>
            {ElementErrorMsg}
        </Fragment>
    );
};
